import { useCustomEvent } from '@sloyd/ui';
import classnames from 'classnames';
import { useSetState } from 'react-use';
import { sortBy } from 'shared-base';
import { Logs } from './ContentRealtime.logs';
import { Box, Wrapper } from './ContentRealtime.style';

export type ContentRealtimeProps = {};

export function ContentRealtime(_props: ContentRealtimeProps) {
  const [boxes, patchBoxes] = useSetState({
    left: { pos: 'left', color: 'red', content: 'left', order: 1, shape: 'rectangle' },
    center: { pos: 'center', color: 'blue', content: 'center', order: 2, shape: 'rectangle' },
    right: { pos: 'right', color: 'green', content: 'right', order: 3, shape: 'rectangle' },
  });

  useCustomEvent(
    'realtime',
    (data) => {
      const { name, call_id, params } = data;
      const { box_position, color, text, new_order, shape } = params;
      const box = (boxes as any)[box_position];

      switch (name) {
        case 'change_box_color':
          patchBoxes({ [box_position]: { ...box, color } });
          break;
        case 'change_box_text':
          patchBoxes({ [box_position]: { ...box, content: text } });
          break;
        case 'change_box_order':
          patchBoxes({ [box_position]: { ...box, order: new_order } });
          break;
        case 'change_box_shape':
          patchBoxes({ [box_position]: { ...box, shape } });
          break;
      }
    },
    [boxes]
  );

  function renderBox(box: Json) {
    const style: React.CSSProperties = {
      backgroundColor: box.color,
    };

    const className = classnames('box', box.shape, {});

    return (
      <Box key={box.pos} className={className} style={style}>
        {box.content}
      </Box>
    );
  }

  function renderBoxes() {
    return Object.values(boxes)
      .sort(sortBy('order'))
      .map((item) => renderBox(item));
  }

  return (
    <Wrapper className='ContentRealtime-wrapper' data-testid='ContentRealtime-wrapper'>
      {renderBoxes()}
      <Logs />
    </Wrapper>
  );
}

export default ContentRealtime;
